import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetLengthOfStayDistributionRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  to: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const GetLengthOfStayDistributionResponseDtoSchema = z.array(
  z.object({
    currentValue: z.number().nullable(),
    marketMedian: z.number().nullable(),
    range: z.string(),
  })
);

export type GetLengthOfStayDistributionRequestDto = z.infer<
  typeof _GetLengthOfStayDistributionRequestDtoSchema
>;
export type GetLengthOfStayDistributionResponseDto = z.infer<
  typeof GetLengthOfStayDistributionResponseDtoSchema
>;

export const getLengthOfStayDistribution = async (
  params: GetLengthOfStayDistributionRequestDto,
  config?: AxiosRequestConfig<GetLengthOfStayDistributionRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(
      `/market-intelligence/facilities/${facilityId}/length-of-stay-distribution`,
      {
        params: restParams,
        ...config,
      }
    )
    .then(responseContract(GetLengthOfStayDistributionResponseDtoSchema));
};
